import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Booking } from "@/components/Booking";
import { Albums } from "@/components/Albums";
import { Videos } from "@/components/Videos";
import { Gallery } from "@/components/Gallery";
import { Entertainment } from "@/components/Entertainment";
import { Contact } from "@/components/Contact";
import { scrollToId } from "@/lib/scroll";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => scrollToId(id), 300);
    }
  }, [location.state]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Booking />
      <Albums />
      <Videos />
      <Gallery />
      <Entertainment />
      <Contact />
    </main>
  );
}
